// extracted by mini-css-extract-plugin
export default {"patchImg":"ModalHeader_patchImg__u8KIz","container":"ModalHeader_container__RIvcw"};